import { render, staticRenderFns } from "./print_college_manpower_report_std.vue?vue&type=template&id=154a9db8&class=text_google&"
import script from "./print_college_manpower_report_std.vue?vue&type=script&lang=js&"
export * from "./print_college_manpower_report_std.vue?vue&type=script&lang=js&"
import style0 from "./print_college_manpower_report_std.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VBtn,VIcon,VSystemBar,VToolbarItems})
